import { SxProps, TextareaAutosize } from "@mui/material"
import { InputWrapper } from "./styled"

type InputProps = {
  label?: string,
  value?: string,
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
  placeholder?: string,
  multiline?: boolean,
  sx?: SxProps,
  adornment?: React.ReactNode
}

const InputBlock = ({ value, onChange, label, placeholder, multiline, sx, adornment }: InputProps) => {

  if (multiline) {
    return (
      <InputWrapper sx={sx}>
        <label>{ label }</label>
        <div className="textarea-wrapper">
          <TextareaAutosize value={value} onChange={onChange} placeholder={placeholder} maxRows={4}/>
        </div>
      </InputWrapper>
    )
  }

  return (
    <InputWrapper sx={sx}>
      <label>{ label }</label>
      <input value={value} onChange={onChange} placeholder={placeholder}/>
      { adornment }
    </InputWrapper>
  )

}

export default InputBlock